import { MoreVertical } from 'lucide-react';
import React from 'react';

interface ChildSafetyProps {
  onOpenMenu: () => void;
}

export default function ChildSafety({ onOpenMenu }: ChildSafetyProps) {
  return (
    <div className="h-screen md:h-auto bg-[#F5F5F5] flex flex-col">
      <div className="bg-[#FFFFFF] px-4 pt-6 pb-4 flex items-start justify-between border-b border-[#E0E0E0]">
        <h1 className="text-[28px] font-[700] leading-[1.2] text-[#212121] m-0 flex-1 pr-4">
          Child Safety
        </h1>
        {/* <button
          onClick={onOpenMenu}
          className="p-2 min-w-[44px] min-h-[44px] flex items-center justify-center bg-transparent border-0 cursor-pointer flex-shrink-0"
          aria-label="Open menu"
        >
          <MoreVertical className="w-6 h-6 text-brand-primary" />
        </button> */}
      </div>

      <div className="flex-1 overflow-y-auto bg-[#FFFFFF] px-4 py-6">
        <div className="max-w-[640px] mx-auto">
          <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
            Child Sexual Exploitation & Abuse
          </h2>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            ISentryx doesn’t allow content that sexualizes or endangers children, real or fictional (e.g. anime, digital images, media, text, illustrations). This includes any visual depictions, sharing third party links, or discussions of sexually explicit conduct involving a child.
          </p>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            It’s prohibited to upload, store, produce, share, or entice anyone to share child sexual abuse material (CSAM), even if the intent is to express outrage or raise awareness about this issue.
          </p>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            We understand that members might want to talk about their children with their connections. Any discussions about children must remain appropriate, relevant, and lawful. In addition, if you decide to include photos of children in your profile, they must be completely clothed, and they cannot appear alone in the image.
          </p>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            This includes any photos from your childhood.
          </p>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            We don’t allow profile photos of the following on the site: babies’, toddlers’ or children’s genitalia or buttocks even when they’re covered or partially covered by emojis.
          </p>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">
            Any violation of this policy will result in a member being removed from ISentryx and reported to the authorities.
            In compliance with U.S. law, if we become aware of apparent child sexual exploitation, child grooming, or child abuse,
            we will report it to the&nbsp;
            <a
              href="https://www.missingkids.org/HOME"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-600 underline hover:text-blue-800"
            >
              National Center for Missing and Exploited Children (NCMEC)
            </a>.
            NCMEC may make the report available to relevant local and global law enforcement authorities.
          </p>
            {/* Footer Section */}
          <div className="border-t border-[#E0E0E0] pt-4 mt-6 text-[13px] text-[#616161]">
            <p className="mb-1">
              <span className="font-semibold text-[#212121]">App Name:</span> ISentryx
            </p>
            <p>
              <span className="font-semibold text-[#212121]">Developer Name:</span> integrativesystems
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
